
export default {
  inject: ['product'],
  data() {
    return {
      product: this.product,
    }
  },
  computed: {
    locale() {
      return `${this.$i18n.locale.split('-')[0]}_${this.$i18n.locale
        .split('-')[1]
        .toUpperCase()}`
    },
    currency() {
      if (this.$i18n.locale.includes('us')) return 'USD'
      if (this.$i18n.locale.includes('ca')) return 'CAD'
      else return ''
    },
  },
}
